<div class="rec-container ">
  <h2>Search Recorded Land by</h2>
  <form (ngSubmit)="onSubmit($event)" #f="ngForm">
    <div class="doc-container">
      <app-recdoc></app-recdoc>
    </div>
    <button class="btn btn-default" type="submit">
      DISPLAY IMAGE
    </button>
  </form>
</div>
